import React from 'react';
import { Href } from '../../components';
export var LicenseComponent = function (_a) {
    var name = _a.name, url = _a.url;
    var nameWrapper = React.createElement("span", null, name);
    return React.createElement("div", null, url ? React.createElement(Href, { href: url }, nameWrapper) : nameWrapper);
};
//# sourceMappingURL=License.js.map